<template>
    <div class="e-download-form" :class="{ 'button-only': buttonOnly }" :style="style">
        <template v-if="buttonOnly">
            <b-btn @click="modalVisible = true" variant="primary">
                <slot name="button">
                    <span v-tr>Download|Télécharger</span>
                </slot>
            </b-btn>
        </template>
        <b-container v-else>
            <b-row>
                <b-col cols="12" md="6">
                    <b-img-lazy fluid center class="document-cover" :src="cover"></b-img-lazy>
                </b-col>
                <b-col cols="12" md="6">
                    <div class="download-text">
                        <slot></slot>
                        <b-btn class="mt-3" @click="modalVisible = true" variant="primary">
                            <slot name="button">
                                <span v-tr>Download|Télécharger</span>
                            </slot>
                        </b-btn>
                    </div>
                </b-col>
            </b-row>

            <slot name="copyright"></slot>
        </b-container>

        <b-modal v-model="modalVisible" :title="'Download'">
            <div v-if="!completed" class="text-left">
                <b-form-group>
                    <label class="required"><span v-tr>Your first name|Votre prénom</span></label>
                    <b-input autocomplete="given-name" required v-model="request.first_name" type="text" maxlength="50"></b-input>
                </b-form-group>
                <b-form-group>
                    <label><span v-tr>Your last name|Votre nom de famille</span></label>
                    <b-input autocomplete="family-name" required v-model="request.last_name" type="text" maxlength="50"></b-input>
                </b-form-group>
                <b-form-group>
                    <label class="required"><span v-tr>Your email address|Votre adresse courriel</span></label>
                    <b-input-group>
                        <b-input-group-text><i class="fas fa-envelope"></i></b-input-group-text>
                        <b-input autocomplete="email" required v-model="request.email" type="email" maxlength="150" :state="isEmailValid"></b-input>
                    </b-input-group>
                </b-form-group>
            </div>
            <div v-else class="text-center">
                <b-img fluid class="document-miniature" :src="cover"></b-img>
                <p v-tr>Thanks, your download link is below.|Merci, votre lien de téléchargement est ci-dessous.</p>
                <b-btn variant="primary" download :href="href" target="_blank" v-tr>Download|Télécharger</b-btn>
            </div>
            <template #modal-footer>
                <template v-if="!completed">
                    <b-btn @click="modalVisible = false" v-tr>Cancel|Annuler</b-btn>
                    <b-btn class="contact-button f-500" :disabled="loading" variant="primary" @click="submit" v-tr>Submit|Envoyer</b-btn>
                </template>
                <template v-else>
                    <b-btn @click="modalVisible = false" v-tr>Close|Fermer</b-btn>
                </template>
            </template>
        </b-modal>
    </div>
</template>

<script>
    import Network from '../helpers/Network.js';
    import {getLanguage} from "../helpers/i18n.js";
    import swal from "sweetalert";

    export default {
        name: `e-download-form`,
        props: {
            href: {type: String, required: true},
            buttonOnly: {type: Boolean, default: false},
            background: {type: String, required: false},
            cover: {type: String, required: false},
            name: {type: String, required: false}
        },
        data() {
            return {
                completed: false,
                modalVisible: false,
                phoneValid: false,
                loading: false,
                request: {
                    first_name: ``,
                    last_name: ``,
                    email: ``,
                    phone: ``,
                    company_name: ``,
                    country: null,
                    features: null,
                    equipment: {},
                    no_equipment: false,
                    router_brands: null,
                    message: ``
                }
            }
        },
        computed: {
            style() {
                return {
                    backgroundImage: `url(${this.background})`
                }
            },
            isEmailValid() {
                return /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/.test(this.request.email);
            }
        },
        activated() {
            window.scrollTo(0, 0);
        },
        methods: {
            onPhoneInput(value) {
                this.phoneValid = value.isValid;
                this.request.phone = value.formatInternational;
                this.request.country = value.countryCode;
            },
            submit() {
                if (isStringEmpty(this.request.first_name) ||
                    isStringEmpty(this.request.last_name) ||
                    isStringEmpty(this.request.email)) {
                    swal(this.tr(`Missing fields|Champs manquants`), this.tr(`One or more required fields are missing.|Un ou plusieurs champs sont manquants.`), `info`);
                    return false;
                }
                let data = {
                    name: this.name,
                    first_name: this.request.first_name,
                    last_name: this.request.last_name,
                    email: this.request.email,
                    phone: this.request.phone,
                    language: getLanguage(),
                    url: window.location.href
                };
                this.loading = true;
                Network.post(`/website/form/download-request`, data)
                    .then(() => {
                        this.loading = false;
                        this.completed = true;
                        this.close();
                    })
                    .catch(() => {
                        this.loading = false;
                    });
            }
        }
    }
</script>

<style lang="scss" scoped>
    .e-download-form {
        &:not(.button-only) {
            padding: 50px 0;
            min-height: 100vh;

            .document-cover {
                margin: 0 auto;
                max-width: calc(100% - 60px);
                box-shadow: 0 5px 30px rgba(0, 0, 0, 0.15);
                border-radius: 10px;
            }
        }
    }

    .document-miniature {
        max-width: 200px;
        max-height: 200px;
        box-shadow: 0 5px 30px rgba(0, 0, 0, 0.15);
        border-radius: 3px;
        object-fit: contain;
        margin-bottom: 15px;
    }
</style>
